import {
  doc,
  getFirestore,
  type DocumentReference,
  type QueryDocumentSnapshot,
  type SnapshotOptions,
} from 'firebase/firestore';
import {
  type UserAssignmentProgressMap,
  isUserAssignmentProgressMap,
} from 'assignments/models/userAssignmentProgressMapInterfaces';
import type {UserId, CourseId} from 'types/common';

export const USER_ASSIGNMENT_PROGRESS_MAP_DOC_CONVERTER = {
  toFirestore: (assignmentProgress: UserAssignmentProgressMap) =>
    assignmentProgress,
  fromFirestore: (
    snapshot: QueryDocumentSnapshot,
    options: SnapshotOptions,
  ) => {
    const data = snapshot.data(options);
    if (!data) {
      console.warn(
        'No assignment progress data found at path: ',
        snapshot?.ref?.path,
      );
      return {};
    }
    if (!isUserAssignmentProgressMap(data)) {
      console.error(
        'Invalid assignment progress data. Silently failing.',
        data,
      );
    }
    return data;
  },
};
export function getUserAssignmentProgressMapDocumentReference({
  userId,
  courseId,
}: {
  userId: UserId;
  courseId: CourseId;
}): DocumentReference<UserAssignmentProgressMap> {
  return doc(
    getFirestore(),
    `users/${userId}/${courseId}/assnProgress`,
  ).withConverter(USER_ASSIGNMENT_PROGRESS_MAP_DOC_CONVERTER);
}
